module.exports = __webpack_public_path__ + "images/bdaa237b8554b57f40cb370014dc4545-contact.png";